import Vue from "vue"
import VueResource from "vue-resource"

import Const from '../js/const'
import { getToken, getUserType, clearUserData } from '../js/data'
import { Message } from 'element-ui';

Vue.use(VueResource);

// 错误提示
function showError(message) {
    Message.error(message);
}

// 将对象拼接为uri
function stringify(obj) {
    let p = []
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            p.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        }
    }
    return p.join('&')
}

function getMark(moduleName) {
    const userType = parseInt(getUserType());
    const TYPE = Const.USER.TYPE
    let mark = 'client/1/'
    switch (userType) {
        case TYPE.ADMIN:
            mark = 'admin/1/'
            break;
        case TYPE.CLIENT:
            mark = 'client/1/'
            break;
    }
    return mark
}

function post(config, moduleName, args = {}) {
    let token = getToken() || ''
    let mark = getMark(moduleName)

    let headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
    let url = `${Const.NET.END_POINT}/${mark}${config[0]}`;

    if (process.env['VUE_APP_API_MODE'] && process.env['VUE_APP_API_MODE'] === 'mix') {
        url = `/api/${mark}${config[0]}`
    }

    let requestData = Object.assign({token}, args)
    console.info(`${url}?${stringify(requestData)}`)

    if (moduleName === 'Export') {
        return `${url}?${stringify(requestData)}`
    }

    return new Promise((resolve, reject) => {

        Vue.http.post(url, stringify(requestData), { headers: headers }).then(
            response => {                       
                let body = response.body;
                if (body.hasOwnProperty('code') && body.code === 0) {
                    if (body.hasOwnProperty('error')) {
                        console.error(body.error);
                        showError(body.error);
                        return reject(body.error);
                    } else {
                        return resolve(body.data)
                    }
                }

                showError(body.message);
                return reject(body);
            },
            error => {
                showError(error.message);
                reject(error);
            }
        )
    })
}


export default function Api(apiList) {
    let api = {}
    for (let moduleName in apiList) {
        let moduleApiList = apiList[moduleName]
        api[moduleName] = {}
        for (let functionName in moduleApiList) {
            let config = moduleApiList[functionName]
            api[moduleName][functionName] = (function(config) {
                return function(...args) {
                    return post(config, moduleName, ...args)
                }
            })(config)
        }
    }
    return api
}
